var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOkAppky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 789,
    height: 128,
    viewBox: "0 0 789 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.456 64.0034C115.456 35.5863 115.456 12.5506 63.9992 12.5506C12.5437 12.5506 12.5437 35.5863 12.5437 64.0034C12.5437 92.4212 12.5437 115.458 63.9992 115.458C115.456 115.458 115.456 92.4212 115.456 64.0034V64.0034ZM63.9992 0C99.347 0 128 28.659 128 64.0034C128 99.3485 99.347 128 63.9992 128C28.653 128 0 99.3485 0 64.0034C0 28.659 28.653 0 63.9992 0V0Z",
    fill: "#005342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.79 108.56C231.92 108.56 251.03 89.8401 251.03 63.7101C251.03 37.5801 231.92 18.8601 205.79 18.8601C179.53 18.8601 160.42 37.5801 160.42 63.7101C160.42 89.8401 179.53 108.56 205.79 108.56ZM205.79 92.1801C189.67 92.1801 179.4 79.8301 179.4 63.7101C179.4 47.4601 189.67 35.2401 205.79 35.2401C221.78 35.2401 232.05 47.4601 232.05 63.7101C232.05 79.8301 221.78 92.1801 205.79 92.1801Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.214 107L301.424 60.9801L335.874 20.2901H313.124L282.444 58.9001V20.2901H263.984V107H282.444V80.3501L289.204 72.1601L315.464 107H338.214Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M460.879 107L427.469 20.2901H404.329L370.919 107H391.849L397.309 92.3101H434.489L439.949 107H460.879ZM429.419 76.0601H402.379L415.899 38.7501L429.419 76.0601Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M487.347 107V76.0601H509.447C528.167 76.0601 538.567 63.3201 538.567 48.2401C538.567 33.0301 528.297 20.2901 509.447 20.2901H468.887V107H487.347ZM506.847 59.8101H487.347V36.5401H506.847C514.127 36.5401 519.717 40.9601 519.717 48.2401C519.717 55.3901 514.127 59.8101 506.847 59.8101Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568.597 107V76.0601H590.697C609.417 76.0601 619.817 63.3201 619.817 48.2401C619.817 33.0301 609.547 20.2901 590.697 20.2901H550.137V107H568.597ZM588.097 59.8101H568.597V36.5401H588.097C595.377 36.5401 600.967 40.9601 600.967 48.2401C600.967 55.3901 595.377 59.8101 588.097 59.8101Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M705.617 107L668.827 60.9801L703.277 20.2901H680.527L649.847 58.9001V20.2901H631.387V107H649.847V80.3501L656.607 72.1601L682.867 107H705.617Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M755.277 107V71.5101L788.427 20.2901H767.497L746.047 55.0001L724.597 20.2901H703.537L736.817 71.5101V107H755.277Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOkAppky);
export default __webpack_public_path__ + "static/media/logo-ok-appky.48b227acdaa39b7a09faff8f4a17fb1d.svg";
export { ForwardRef as ReactComponent };